import { KpiQuery, KpiResponse } from '@/api-client/models/utilization/Contracts'
import { useFetchPost } from './useFetch'
import { Ref } from 'vue'

export const useFetchKpi = (query: (KpiQuery | null) | Ref<KpiQuery | null>) => {
  return useFetchPost<KpiQuery, KpiResponse>('iot/v2/utilization/kpi', query)
}
